function dataLayer() {
  return (window as any).dataLayer || [];
}

function dataLayerPush(event: string, data: any) {
  dataLayer().push({ event, ...data });
}

export { dataLayer, dataLayerPush };
